import { type AxiosRequestConfig } from 'axios'

const getUserLanguagesList = (id?: string): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: id ? `/users/${id}/info/languages/list` : `/user/info/languages/list`
  }
}

export { getUserLanguagesList }
